import { RefObject, useEffect, useState } from 'react'
import { HERO_STAGE_WIDTH } from './constants'

// The scene's choreography is authored in fixed 640x573 coordinates, so the
// whole stage is scaled to whatever width the hero column gets rather than
// each element being re-expressed in relative units.
const useHeroScale = (frameRef: RefObject<HTMLDivElement | null>) => {
  const [scale, setScale] = useState(1)

  useEffect(() => {
    const frame = frameRef.current

    if (!frame) {
      return
    }

    const measure = () => {
      const { width } = frame.getBoundingClientRect()

      if (width > 0) {
        setScale(width / HERO_STAGE_WIDTH)
      }
    }

    measure()

    if (typeof ResizeObserver === 'undefined') {
      return
    }

    const observer = new ResizeObserver(measure)
    observer.observe(frame)

    return () => observer.disconnect()
  }, [frameRef])

  return scale
}

export default useHeroScale
